import "./ts/navigation";
import "./ts/menu";
import "./ts/scroller";
import "./ts/slider";
import "./ts/accordion";
import "./ts/video";
// import MatchHeight from '@tannerhodges/match-height';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });

import './main.css';

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll<HTMLElement>('.item');

  items.forEach(item => {
    const mockup = item.querySelector<HTMLElement>('.item__mockup');
    const image = mockup?.querySelector<HTMLImageElement>('img');
    const lens = mockup?.querySelector<HTMLElement>('.zoom-lens');

    if (!mockup || !image || !lens) return;

    mockup.addEventListener('mousemove', (e: MouseEvent) => {
      const rect = mockup.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Show lens
      lens.style.display = 'block';

      // Position the lens centered on the cursor
      lens.style.left = `${x - lens.offsetWidth / 2}px`;
      lens.style.top = `${y - lens.offsetHeight / 2}px`;

      // Set the zoomed background image
      lens.style.backgroundImage = `url(${image.src})`;

      // Calculate zoom position as percentage
      const zoomX = (x / rect.width) * 100;
      const zoomY = (y / rect.height) * 100;

      lens.style.backgroundPosition = `${zoomX}% ${zoomY}%`;
    });

    mockup.addEventListener('mouseleave', () => {
      lens.style.display = 'none';
    });
  });
});
